import { Component } from '@angular/core';
import { TextHeaderComponent } from '../text-header/text-header.component';
import { TextComponent } from '../text/text.component';
@Component({
    selector: 'section-2',
    imports: [TextHeaderComponent, TextComponent],
    templateUrl: './section-2.component.html',
    styleUrls: ['./section-2.component.scss', '../section.scss']
})
export class Section2Component {

}
